/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Id_RoomInputs */

const fr_rooms_id_room = /** @type {(inputs: Rooms_Id_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`id_room (Dedge)`)
};

const en_rooms_id_room = /** @type {(inputs: Rooms_Id_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`id_room (Dedge)`)
};

/**
* | output |
* | --- |
* | "id_room (Dedge)" |
*
* @param {Rooms_Id_RoomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_id_room = /** @type {((inputs?: Rooms_Id_RoomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Id_RoomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_id_room(inputs)
	return en_rooms_id_room(inputs)
});